import { Controller } from "@hotwired/stimulus"

// Back-to-top FAB. Mounted on `<body>` in `estratos.erb`. Self-disables on
// pages that are shorter than ~1.5 viewports (no real scrolling), and on
// reduced-motion the scroll-to-top happens instantly instead of smoothly.
//
// Markup expected: <button data-top-target="button"> somewhere inside the
// controller element. The controller adds/removes `.visible` based on scroll
// position.
export default class extends Controller {
  static targets = ["button"]

  connect() {
    if (!this.hasButtonTarget) return
    this.reduced = matchMedia("(prefers-reduced-motion: reduce)").matches
    this.onScroll = this.update.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })
    window.addEventListener("resize", this.onScroll, { passive: true })
    this.update()
  }

  disconnect() {
    if (this.onScroll) {
      window.removeEventListener("scroll", this.onScroll)
      window.removeEventListener("resize", this.onScroll)
    }
  }

  update() {
    const docH = document.documentElement.scrollHeight
    const vh = window.innerHeight
    const tooShort = docH < vh * 1.5
    const scrolled = window.scrollY > vh * 0.6
    const show = !tooShort && scrolled
    this.buttonTarget.classList.toggle("visible", show)
  }

  scrollUp(event) {
    event?.preventDefault?.()
    window.scrollTo({
      top: 0,
      behavior: this.reduced ? "auto" : "smooth",
    })
  }
}
